module.exports = __webpack_public_path__ + "img/accident.8eda48ac.png";